import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CartContext } from '../../context/cartcontext.js';
import "../../styles/products/products.css";

function Body_tasche() {
    const [products, setProducts] = useState([]);
    const [sortOrder, setSortOrder] = useState("asc");
    const [selectedImages, setSelectedImages] = useState({});
    const { addToCart } = useContext(CartContext);
    const navigate = useNavigate();

    useEffect(() => {
        axios.get("https://www.nurleder.de/api/tasche/")
            .then((res) => {
                setProducts(res.data);
                const initial = {};
                res.data.forEach(p => {
                    initial[p.product_id] = p.images.length > 0 ? p.images[0].image : null;
                });
                setSelectedImages(initial);
            })
            .catch(err => console.error("Fehler beim Laden:", err));
    }, []);

    const handleThumbnailClick = (productId, mediaUrl) => {
        setSelectedImages(prev => ({
            ...prev,
            [productId]: mediaUrl
        }));
    };

    const sorted = [...products].sort((a, b) =>
        sortOrder === "asc" ? a.price - b.price : b.price - a.price
    );

    const getStatus = (s) =>
        s === 1 ? "Verfügbar" : s === 2 ? "Begrenzt" : s === 3 ? "Ausverkauft" : "-";

    const scrollThumbnails = (productId, direction) => {
        const row = document.getElementById(`thumb-row-${productId}`);
        if (row) {
            row.scrollBy({
                left: direction * 80,
                behavior: 'smooth',
            });
        }
    };

    return (
        <section className="product-page">
            <h2>Tasche</h2>

            <div className="sort-container">
                <label>Sortieren nach:</label>
                <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
                    <option value="asc">Preis aufsteigend</option>
                    <option value="desc">Preis absteigend</option>
                </select>
            </div>

            <div className="grid">
                {sorted.map((product) => (
                    <div key={product.product_id} className="product-card">
                        <div className="image-wrapper">
                            {/* Hauptbild oder Video */}
                            {selectedImages[product.product_id]?.endsWith(".mp4") ? (
                                <video
                                    src={selectedImages[product.product_id]}
                                    controls
                                    autoPlay
                                    className="main-image"
                                    style={{ cursor: "pointer" }}
                                />
                            ) : (
                                <img
                                    src={selectedImages[product.product_id] || product.image}
                                    alt={product.name}
                                    className="main-image"
                                    onClick={() => navigate(`/product/${product.product_id}`)}
                                    style={{ cursor: "pointer" }}
                                />
                            )}

                            <div className="thumbnail-carousel-wrapper">
                                <div className="thumbnail-scroll-container">
                                    <div className="thumbnail-row" id={`thumb-row-${product.product_id}`}>
                                        {product.images.map((imgObj, i) => (
                                            <img
                                                key={i}
                                                src={imgObj.image}
                                                alt={`Vorschau ${product.name} ${i + 1}`}
                                                className={`thumbnail ${selectedImages[product.product_id] === imgObj.image ? 'active' : ''}`}
                                                onClick={() => handleThumbnailClick(product.product_id, imgObj.image)}
                                            />
                                        ))}

                                        {/* Video-Vorschaubild mit Play-Icon */}
                                        {product.video && (
                                            <div
                                                className={`thumbnail video-thumbnail ${selectedImages[product.product_id] === product.video ? 'active' : ''}`}
                                                onClick={() => handleThumbnailClick(product.product_id, product.video)}
                                            >
                                                <video
                                                    src={product.video}
                                                    muted
                                                    loop
                                                    playsInline
                                                    className="video-element"
                                                />
                                                <div className="play-icon">▶</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="product-info">
                            <p className="name">{product.name}</p>
                            <p className="status">Status: {getStatus(product.status)}</p>
                            <p className="status">Description: {product.description}</p>
                            <p className="price">Preis: {parseFloat(product.price).toLocaleString("de-DE")} €</p>
                            <button
                                className="cart-btn"
                                onClick={() => addToCart({
                                    ...product,
                                    image: selectedImages[product.product_id] || product.image
                                })}
                            >
                                🛒 In den Warenkorb
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Body_tasche;
